import { render } from "./ListeTypeComptePage.vue?vue&type=template&id=24b0a695&ts=true"
import script from "./ListeTypeComptePage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeComptePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__